import React from "react";
import { Link } from "gatsby";
import RevealAnimation from "../RevealAnimation";
import "./insightsIntroSection.scss";

function InsightsIntroSection() {
  const categories = [
    {
      icon: (
        <svg
          width="28"
          height="28"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
          <polyline points="14 2 14 8 20 8" />
          <line x1="16" y1="13" x2="8" y2="13" />
          <line x1="16" y1="17" x2="8" y2="17" />
        </svg>
      ),
      title: "Articles",
      description:
        "In-depth analysis on emerging technologies, engineering practices, and digital strategies that shape the future.",
      link: "/insights/articles",
      color: "#db4435",
      count: "50+",
    },
    {
      icon: (
        <svg
          width="28"
          height="28"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
          <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" />
        </svg>
      ),
      title: "White Papers",
      description:
        "Research-driven reports and proprietary frameworks to help you make informed technology decisions.",
      link: "/insights/white-papers",
      color: "#2563eb",
      count: "10+",
    },
    {
      icon: (
        <svg
          width="28"
          height="28"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
          <circle cx="9" cy="7" r="4" />
          <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
          <path d="M16 3.13a4 4 0 0 1 0 7.75" />
        </svg>
      ),
      title: "Client Stories",
      description:
        "Real-world case studies showcasing how we've helped businesses transform and grow with technology.",
      link: "/clients",
      color: "#059669",
      count: "15+",
    },
    {
      icon: (
        <svg
          width="28"
          height="28"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
        </svg>
      ),
      title: "Industry Insights",
      description:
        "Perspectives on business strategy, market trends, and innovation from our team of digital leaders.",
      link: "/insights/articles",
      color: "#d97706",
      count: "30+",
    },
  ];

  return (
    <section className="insights-intro-section">
      <div className="body-container">
        {/* Section header */}
        <div className="intro-header">
          <RevealAnimation animation="slide-up" delay={0.1}>
            <span className="intro-badge">
              <span className="badge-icon">
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <circle cx="12" cy="12" r="10" />
                  <line x1="12" y1="16" x2="12" y2="12" />
                  <line x1="12" y1="8" x2="12.01" y2="8" />
                </svg>
              </span>
              Explore Our Content
            </span>
            <h2 className="intro-title">
              Knowledge that drives
              <br />
              <span className="intro-title-accent">real business growth</span>
            </h2>
            <p className="intro-text">
              From deep technical articles to strategic white papers and real
              client stories - we share what we've learned building products
              across industries to help you make better decisions, faster.
            </p>
          </RevealAnimation>
        </div>

        {/* Category Cards Grid */}
        <div className="intro-categories-grid">
          {categories.map((cat, i) => (
            <RevealAnimation
              key={i}
              animation="slide-up"
              delay={0.15 + i * 0.08}
            >
              <Link
                to={cat.link}
                className="intro-category-card"
                style={{ "--card-accent": cat.color }}
              >
                <div className="category-card-top">
                  <div className="category-card-icon">{cat.icon}</div>
                  <span className="category-card-count">{cat.count}</span>
                </div>
                <h3 className="category-card-title">{cat.title}</h3>
                <p className="category-card-desc">{cat.description}</p>
                <div className="category-card-link">
                  Explore {cat.title}
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <line x1="5" y1="12" x2="19" y2="12" />
                    <polyline points="12 5 19 12 12 19" />
                  </svg>
                </div>
              </Link>
            </RevealAnimation>
          ))}
        </div>
      </div>
    </section>
  );
}

export default InsightsIntroSection;
